import { render, staticRenderFns } from "./sfc-breadcrumbs.vue?vue&type=template&id=3df603e5&scoped=true&lang=pug&"
import script from "./sfc-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./sfc-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./sfc-breadcrumbs.vue?vue&type=style&index=0&id=3df603e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df603e5",
  null
  
)

export default component.exports